import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  UserCog,
  FolderKanban,
  CheckSquare,
  FileText,
  FileInput,
  Ticket,
  LifeBuoy,
  MessageSquare,
  Megaphone,
  BookOpen,
  Clock,
  Receipt,
  CreditCard,
  BarChart3,
  ShieldCheck,
  Bell,
} from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { NAV_BY_ROLE, ROLE_LABELS } from '../../utils/roles';

// Maps the `icon` key on each NAV_BY_ROLE entry to a lucide-react component.
// Icons are rendered white via CSS (stroke="currentColor" + sidebar-link color).
const ICONS = {
  dashboard: LayoutDashboard,
  clients: Users,
  employees: UserCog,
  projects: FolderKanban,
  tasks: CheckSquare,
  documents: FileText,
  documentRequests: FileInput,
  tickets: Ticket,
  clientSupport: LifeBuoy,
  communication: MessageSquare,
  announcements: Megaphone,
  knowledgeBase: BookOpen,
  timesheets: Clock,
  invoices: Receipt,
  payments: CreditCard,
  reports: BarChart3,
  auditLogs: ShieldCheck,
  notifications: Bell,
};

export default function Sidebar() {
  const { actor } = useAuth();
  if (!actor) return null;

  const links = NAV_BY_ROLE[actor.role] || [];
  const displayName = actor.profile.name || actor.profile.clientName;

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <div className="brand-name">Audit Firm Portal</div>
        <div className="brand-role">
          {displayName} &middot; {ROLE_LABELS[actor.role] || actor.role}
        </div>
      </div>
      <nav className="sidebar-nav">
        {links.map((link) => {
          const Icon = ICONS[link.icon];
          return (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
            >
              {Icon && <Icon className="sidebar-link-icon" size={17} strokeWidth={2} aria-hidden="true" />}
              <span>{link.label}</span>
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
}
